import { useEffect, useState } from 'react';
import { Dimmer, Header, Loader, Table } from 'semantic-ui-react';
import { connect, ConnectedProps, useSelector } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { StoreState } from '../../types/state';
import {
  getScheduledTasksByParentId,
  updateScheduledTask,
} from '../../redux/actions/tasks';
import EditDialog from '../Common/EditDialog';
import Actions from '../Common/Actions';
import scheduledTaskFormSchema from './scheduledTaskFormSchema.json';
import Filters from '../Common/Filters';
import { ScheduledTaskColumns } from '../../constant';
import { getLocalTime, timestampColumns } from '../../utils';

type ScheduledTaskListProps = {
  parentTaskId: string;
};

const ScheduledTaskList = (
  props: ScheduledTaskListProps & ScheduledTaskListReduxProps
) => {
  const { tasks, taskIds, parentTaskId, getScheduledTasksByParentId } = props;

  const timezone = useSelector((state: any) => state.auth.timezone);
  const useLocalTime = timezone === 'UTC' ? false : true;

  const [editTask, setEditTask] = useState(undefined);

  const [filteredTasks, setFilteredTasks] = useState([]);

  useEffect(() => {
    if (!taskIds && parentTaskId) {
      getScheduledTasksByParentId(parentTaskId);
    }
  }, [parentTaskId, taskIds, getScheduledTasksByParentId]);

  const handleDisable = (id: string) => {
    console.log(tasks);
    const task = tasks[id];
    if (task) {
      props.updateScheduledTask({ ...task, Enabled: !task.Enabled });
    }
  };

  const handleUpdate = (data: any) => {
    props.updateScheduledTask({ ...editTask, ...data });
  };

  return (
    <div>
      <Header>Scheduled Tasks</Header>
      {props.isLoading ? (
        <Dimmer active>
          <Loader />
        </Dimmer>
      ) : null}
      {Object.keys(tasks).length > 0 && (
        <Filters
          originalList={Object.values(tasks)}
          filteredLists={filteredTasks}
          allowedParams={['TaskName', 'TaskId', 'ClientId', 'TimeZone']}
          setFilteredLists={setFilteredTasks}
        />
      )}
      {editTask && (
        <EditDialog
          update={handleUpdate}
          // formData={editTask}
          onClose={() => {
            setEditTask(undefined);
          }}
          formSchema={scheduledTaskFormSchema}
        />
      )}
      {taskIds && (
        <Table>
          <Table.Header>
            {taskIds.length > 0 &&
              ScheduledTaskColumns.concat('Actions').map((header) => {
                return <Table.HeaderCell>{header}</Table.HeaderCell>;
              })}
          </Table.Header>
          <Table.Body>
            {filteredTasks.map((task: any) => {
              return (
                <Table.Row key={task.id}>
                  {ScheduledTaskColumns.map((elem: any) => {
                    return (
                      <Table.Cell key={`${elem}-${task.id}`}>
                        {timestampColumns.includes(elem) && useLocalTime
                          ? getLocalTime(task[elem])
                          : task[elem] === false
                          ? 'false'
                          : task[elem] && task[elem.toString()]}
                      </Table.Cell>
                    );
                  }).concat(
                    <Table.Cell key={'action' + task.id}>
                      <Actions
                        showEdit
                        showEnable
                        showDetails
                        isDisabled={!task.Enabled}
                        onDisable={() => {
                          handleDisable(task.id);
                        }}
                        onEdit={() => {
                          setEditTask(task);
                        }}
                        detailsLink={`/tasks/scheduled-task/${task.id}`}
                      />
                    </Table.Cell>
                  )}
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      )}
    </div>
  );
};

const mapStateToProps = (state: StoreState, props: ScheduledTaskListProps) => {
  const { parentTaskId } = props;
  return {
    taskIds: state.tasks.parentTasks[parentTaskId],
    tasks: state.tasks.scheduledTasks,
    isLoading: state.tasks.isLoading,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      getScheduledTasksByParentId,
      updateScheduledTask,
    },
    dispatch
  );
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type ScheduledTaskListReduxProps = ConnectedProps<typeof connector>;

export default connector(ScheduledTaskList);
